/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBluetooth = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15.586 16 13 18.586v-5.172zM13 5.414l2.548 2.548L13 10.255zm-2 6.64-4.669 4.203 1.338 1.486L11 14.745v8.67L18.414 16l-4.172-4.172 4.21-3.79L11 .586v8L7.707 5.293 6.293 6.707 11 11.414z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBluetooth as Bluetooth };
